'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import Image from 'next/image';
import useEmblaCarousel from 'embla-carousel-react';
import { useRouter } from 'next/navigation';
import Lightbox from '@/components/atoms/Lightbox';
import { WhereToVoteIcon } from '@/components/atoms/Icons';
import { getHeartVisitCount } from '@/shared/heartVisits';
import LoginModal from '@/components/auth/loginModal';
import { setPostLoginRedirect } from '@/lib/client/postLoginRedirect';
import HeartSaveButton from '@/components/organisms/HeartSaveButton';
import HeartHeroLeftSection from './HeartHeroLeftSection';
import { getMarkerIcon } from '../../explore/components/markerIcons';
export default function HeartHeroImages(t0) {
  const $ = _c(42);
  const {
    images: t1,
    entity,
    isArchived
  } = t0;
  const images = t1 === undefined ? [] : t1;
  const count = images.length;
  const visitCount = getHeartVisitCount(entity);
  const router = useRouter();
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const t2 = entity?.type;
  let t3;
  if ($[0] !== t2) {
    t3 = getMarkerIcon(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const iconConfig = t3;
  let t4;
  if ($[2] !== setShowLoginModal) {
    t4 = () => {
      setPostLoginRedirect(window.location.href);
      setShowLoginModal(true);
    };
    $[2] = setShowLoginModal;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const openLoginModal = t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const mq = window.matchMedia("(min-width: 1024px)");
      const update = () => setIsDesktop(mq.matches);
      update();
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    };
    t6 = [];
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useEffect(t5, t6);
  const t7 = count > 1;
  let t8;
  if ($[6] !== t7) {
    t8 = {
      loop: t7,
      skipSnaps: false,
      dragFree: false
    };
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const [emblaRef, embla] = useEmblaCarousel(t8);
  let t9;
  if ($[8] !== embla) {
    t9 = () => {
      if (!embla) {
        return;
      }
      setSelectedIndex(embla.selectedScrollSnap());
    };
    $[8] = embla;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const onSelect = t9;
  let t10;
  let t11;
  if ($[10] !== embla || $[11] !== onSelect) {
    t10 = () => {
      if (!embla) {
        return;
      }
      embla.on("select", onSelect);
      embla.on("init", onSelect);
    };
    t11 = [embla, onSelect];
    $[10] = embla;
    $[11] = onSelect;
    $[12] = t10;
    $[13] = t11;
  } else {
    t10 = $[12];
    t11 = $[13];
  }
  useEffect(t10, t11);
  let t12;
  if ($[14] !== setActiveIndex) {
    t12 = index => {
      setActiveIndex(index);
    };
    $[14] = setActiveIndex;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const openLightbox = t12;
  let t13;
  if ($[16] !== setActiveIndex) {
    t13 = () => setActiveIndex(null);
    $[16] = setActiveIndex;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const closeLightbox = t13;
  let t14;
  if ($[18] !== count || $[19] !== setActiveIndex) {
    t14 = () => setActiveIndex(p => (p + 1) % count);
    $[18] = count;
    $[19] = setActiveIndex;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const goNext = t14;
  let t15;
  if ($[21] !== count || $[22] !== setActiveIndex) {
    t15 = () => setActiveIndex(p_0 => (p_0 - 1 + count) % count);
    $[21] = count;
    $[22] = setActiveIndex;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const goPrev = t15;
  let parentClass = "grid gap-4 w-full 2xl:h-[582px] xl:h-[500px] lg:h-[460px]";
  let getItemClass = _temp;
  if (count === 1) {
    parentClass = "grid grid-cols-1 2xl:h-[582px] xl:h-[500px] lg:h-[460px]";
    getItemClass = _temp2;
  }
  if (count === 2) {
    parentClass = "grid grid-cols-2 gap-2 2xl:h-[582px] xl:h-[500px] lg:h-[460px]";
    getItemClass = _temp3;
  }
  if (count >= 3) {
    parentClass = "grid gap-1 xl:grid-cols-[67%_33%] grid-cols-[60%_40%] grid-rows-2 2xl:h-[582px] xl:h-[500px] lg:h-[460px]";
    getItemClass = _temp4;
  }
  const maxImages = images.slice(0, Math.min(count, 3));
  const showLightbox = activeIndex !== null;
  let t16;
  if ($[24] !== router) {
    t16 = e => {
      e.stopPropagation();
      e.preventDefault();
      router.push("/leaderboard");
    };
    $[24] = router;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  const handleClick = t16;
  const t17 = `${isDesktop ? "" : "relative  w-[calc(100%+32px)] -ml-4"}`;
  const t18 = isDesktop ? <div className={parentClass}>{maxImages.map((img, i_1) => <div key={i_1} role="button" tabIndex={0} onClick={() => openLightbox(i_1)} onKeyDown={e_0 => {
      if ((e_0.key === "Enter" || e_0.key === " ") && isDesktop) {
        e_0.preventDefault();
        openLightbox(i_1);
      }
    }} className={`${getItemClass(i_1)} cursor-pointer relative`}><SafeImage src={img} alt={`Image ${i_1 + 1}`} count={maxImages.length} className="object-cover" />{i_1 === 0 && <><div className="absolute inset-0 pointer-events-none z-0 [background:linear-gradient(180deg,rgba(0,0,0,0.00)_69.33%,rgba(0,0,0,0.40)_99.86%),0]" />{visitCount !== null && visitCount > 0 && <button type="button" onClick={handleClick} className="absolute bottom-4 left-4 flex items-center gap-1.5 text-white z-10 cursor-pointer transition"><WhereToVoteIcon /><span className="text-[13px]">{visitCount.toLocaleString()} Visits</span></button>}{!isArchived && <div className="absolute bottom-2 right-4 z-10" onClick={_temp5}><HeartSaveButton heartId={entity?.id} heartName={entity?.name} iconOnly={true} className="text-[13px] text-white gap-1" onUnauthenticatedClick={openLoginModal} /></div>}</>}{count > 3 && i_1 === 2 && <div className="absolute inset-0 bg-linear-to-b from-black/10 to-black/50 flex items-center justify-center text-white" onClick={e_2 => {
        e_2.stopPropagation();
        openLightbox(0);
      }}><span className="bg-black/50 rounded-full py-2 px-4 text-sm font-semibold">All Photos</span></div>}</div>)}</div> : <div className="md:h-[800px] h-[680px] w-full max-w-full relative lg:hidden md:rounded-b-3xl rounded-b-[20px] bg-white"><div className="md:rounded-b-3xl rounded-b-[20px] inset-0 absolute z-10 pointer-events-none bg-[linear-gradient(#00000063_0%,#17171736_25%_27%,#0000004d_100%)]"><span className="sr-only">overlay</span></div>{entity.sponsor && <div className="text-white w-[100px] md:text-sm text-xs font-normal leading-[1.2em] lg:hidden block absolute top-3.5 right-4 z-10 text-right"><span className="md:text-xs text-[10px] block bottom-full text-[#CECECE]">Patron Partner</span>{entity.sponsor}</div>}<div className="absolute z-10 bottom-1 p-4 w-full"><div className="absolute top-0 -mt-1.5 pb-2 left-0 right-0 z-30"><div className="relative flex items-center justify-center">{visitCount !== null && visitCount > 0 && <button type="button" onClick={handleClick} className="absolute left-4 flex items-center gap-1 text-white text-[13px] cursor-pointer transition"><WhereToVoteIcon /><span>{visitCount.toLocaleString()} Visits</span></button>}{count > 1 && <div className="flex gap-2">{images.map((_, i_2) => <button key={i_2} onClick={() => embla && embla.scrollTo(i_2)} className={`w-1.5 h-1.5 rounded-full transition-all cursor-pointer ${selectedIndex === i_2 ? "bg-white w-4!" : "bg-white/60 hover:bg-white/80"}`} />)}</div>}<div className="absolute right-4" onClick={_temp6}><HeartSaveButton heartId={entity?.id} heartName={entity?.name} iconOnly={true} className="text-[13px] text-white gap-1" onUnauthenticatedClick={openLoginModal} /></div></div></div><HeartHeroLeftSection entity={entity} /></div><div className="overflow-hidden md:rounded-b-3xl rounded-b-[20px]" ref={emblaRef}><div className="flex">{images && images.length > 0 ? images.map((img_0, i_3) => <button key={i_3} type="button" onClick={() => openLightbox(i_3)} className="relative flex-[0_0_100%] w-full md:h-[800px] h-[680px] cursor-pointer"><SafeImage src={img_0} alt={`Image ${i_3 + 1}`} className="object-cover" /></button>) : <div className="relative inset-0 flex items-center justify-center h-[360px] w-full"><Image src={iconConfig?.src} alt={iconConfig?.alt} width={200} height={200} className="opacity-70" /></div>}</div></div></div>;
  let t19;
  if ($[26] !== activeIndex || $[27] !== closeLightbox || $[28] !== goNext || $[29] !== goPrev || $[30] !== images || $[31] !== setActiveIndex || $[32] !== showLightbox) {
    t19 = showLightbox && <Lightbox images={images} activeIndex={activeIndex} close={closeLightbox} goNext={goNext} goPrev={goPrev} goTo={setActiveIndex} key={activeIndex} />;
    $[26] = activeIndex;
    $[27] = closeLightbox;
    $[28] = goNext;
    $[29] = goPrev;
    $[30] = images;
    $[31] = setActiveIndex;
    $[32] = showLightbox;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== setShowLoginModal || $[35] !== showLoginModal) {
    t20 = showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} />;
    $[34] = setShowLoginModal;
    $[35] = showLoginModal;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t17 || $[38] !== t18 || $[39] !== t19 || $[40] !== t20) {
    t21 = <div className={t17}>{t18}{t19}{t20}</div>;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  return t21;
}
function _temp6(e_3) {
  return e_3.stopPropagation();
}
function _temp5(e_1) {
  return e_1.stopPropagation();
}
function _temp4(i_0) {
  if (i_0 === 0) {
    return "relative col-span-1 row-span-2 w-full h-full overflow-hidden rounded-l-xl";
  }
  if (i_0 === 1) {
    return "relative w-full h-full overflow-hidden rounded-tr-xl";
  }
  if (i_0 === 2) {
    return "relative w-full h-full overflow-hidden rounded-br-xl";
  }
  return "hidden";
}
function _temp3(i) {
  return i === 0 ? "relative w-full h-full overflow-hidden rounded-l-xl" : "relative w-full h-full overflow-hidden rounded-r-xl";
}
function _temp2() {
  return "relative w-full h-full overflow-hidden rounded-xl bg-black";
}
function _temp() {
  return "relative w-full h-full overflow-hidden rounded-xl bg-black";
}
function SafeImage(t0) {
  const $ = _c(13);
  const {
    src,
    alt,
    className,
    count
  } = t0;
  const [isWider, setIsWider] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      const img = e.target;
      setIsWider(img.naturalWidth > img.naturalHeight);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleLoad = t1;
  if (!src) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="w-full h-full bg-gray-200 flex items-center justify-center" />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (isWider === null || count === 2) {
    let t2;
    if ($[2] !== alt || $[3] !== className || $[4] !== src) {
      t2 = <Image src={src} alt={alt} fill={true} className={className} onLoad={handleLoad} />;
      $[2] = alt;
      $[3] = className;
      $[4] = src;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  } else {
    if (isWider) {
      let t2;
      if ($[6] !== alt || $[7] !== className || $[8] !== src) {
        t2 = <Image src={src} alt={alt} fill={true} className={className} />;
        $[6] = alt;
        $[7] = className;
        $[8] = src;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      return t2;
    } else {
      let t2;
      if ($[10] !== alt || $[11] !== src) {
        t2 = <Image src={src} alt={alt} height={0} width={0} className="h-auto w-full absolute top-0" />;
        $[10] = alt;
        $[11] = src;
        $[12] = t2;
      } else {
        t2 = $[12];
      }
      return t2;
    }
  }
}